import Tippy from "@tippyjs/react";
import 'tippy.js/dist/tippy.css';
/**
 * Notification indicator wrapped in Tippy tooltip. Can used with Tab Buttons to indicate that an area is not fully filled in.
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - UI
 */
export const MissingItemsIndicator = ({ className = "", tooltipLabel, tooltipDisabled = false, showIndicator }) => {

    if(showIndicator === false) return null

    return (
        <Tippy
            content={tooltipLabel}
            disabled={tooltipDisabled}
            placement="right"
            delay={[100, 0]}
        >
            <i className={`fa-solid fa-circle ${className} text-amber-500 ml-2 text-xs`}></i>
        </Tippy>
    );
};